__turbopack_context__.v({
  "image": "HeroImage-module-scss-module__MNvSca__image",
});
